import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ReferenceLine,
  Tooltip,
  Legend,
} from "recharts";
import { StyledLineGraph } from "./style";
import React, { useEffect, useState } from "react";
import { ACCENT_COLOR } from "../../../consts/const";
/**
 *
 * @param {Object} param
 * @param {Array} param.data
 * @param {string} param.xKey
 * @param {string[]} param.yKey
 * @param {string} param.yKey.label
 * @param {string} param.yKey.key
 * @param {string} [param.yLabel]
 * @param {boolean} [param.multiGraphMode]
 * @param {string} [param.unit] - y축 단위
 * @returns
 */
export const LineGraph = ({
  data,
  xKey,
  yKey,
  yLabel,
  multiGraphMode,
  unit,
}) => {
  const [currentViewKey, setCurrentViewKey] = useState(Object.keys(data).pop());
  const COLOR = [
    "#5987D2",
    "#F06548",
    "#FFD374",
    "#FD51A3",
    "#3577F1",
    "#51ADF6",
    "#1EC9B7",
  ];

  const CustomizedDot = (props) => {
    const { cx, cy, value, stroke } = props;
    return (
      <g>
        {value !== undefined && (
          <React.Fragment>
            <circle cx={cx} cy={cy} r={4} fill={"white"} stroke={stroke} />
            {value !== 0 && (
              <text x={cx} y={cy - 12} fill={stroke} textAnchor="middle">
                {value}
              </text>
            )}
          </React.Fragment>
        )}
      </g>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload) {
      return (
        <div className="custom-tooltip">
          <p className="label">{label}</p>
          <div className="wrap">
            {payload.map((item, idx) => (
              <p key={idx} style={{ color: item.color }}>
                <span>{item.name}: </span> {item.value}
                {unit && unit}
              </p>
            ))}
          </div>
        </div>
      );
    }
  };

  const CustomLabel = (props) => {
    const { x, y, value, width, fill, stroke, strokeWidth } = props;
    if (value === 0) return null;
    return (
      <text
        x={x + width / 2}
        y={y}
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
        textAnchor="middle"
        dy={-6}
      >
        {value}
      </text>
    );
  };

  useEffect(() => {
    setCurrentViewKey(Object.keys(data).pop());
  }, [data]);

  return (
    <StyledLineGraph>
      <div className="graph-wrap">
        {data && (multiGraphMode ? data[currentViewKey] : data) && (
          <LineChart
            width={1300}
            height={300}
            data={multiGraphMode ? data[currentViewKey] : data}
            margin={{ top: 20, right: 10, left: 10 }}
          >
            <XAxis tickSize={12} dataKey={xKey} />
            <YAxis
              tickSize={12}
              tickCount={5}
              label={
                yLabel && {
                  value: yLabel,
                  angle: -90,
                  position: "insideLeft",
                }
              }
            />
            <CartesianGrid stroke="#ddd" strokeDasharray="0" />
            <ReferenceLine y={0} stroke="#090808" />
            <ReferenceLine
              x={multiGraphMode ? data[currentViewKey][0][xKey] : data[0][xKey]}
              stroke="#090808"
            />
            <Tooltip content={<CustomTooltip />} />
            {Object.keys(...yKey).includes("label") && yKey.length > 1 && (
              <Legend />
            )}
            {yKey.map((y, idx) => (
              <Line
                key={idx}
                type="linear"
                dataKey={y.key}
                stroke={COLOR[idx]}
                strokeWidth={1.6}
                dot={<CustomizedDot />}
                animationDuration={500}
                {...(y.label ? { name: y.label } : {})}
              />
            ))}
          </LineChart>
        )}
        {multiGraphMode && (
          <div className="button-wrap">
            {Object.keys(data).map((key, index) => (
              <button
                key={index}
                className={key === currentViewKey ? "active" : ""}
                onClick={() => setCurrentViewKey(key)}
              >
                <span
                  className="circle"
                  style={{
                    backgroundColor: ACCENT_COLOR[index],
                  }}
                />
                <p>{key}</p>
              </button>
            ))}
          </div>
        )}
      </div>
    </StyledLineGraph>
  );
};
